import { ReferenceImageTriggerProps } from 'screens/Schedule/PostPromptsSection/Types'
import { ModalTrigger } from 'almanac-ui/Modal/ModalTrigger'
import { ImageMenuModal } from 'components/ImageMenu/ImageMenuModal/ImageMenuModal'
import { ImageMenuSelectedImage, Provider } from 'components/ImageMenu/ImageMenuModal/ImageMenuContext'
import { SupportedMediaType } from 'components/Wizards/schemas/Types'
import { getMimeTypesForMediaTypes } from 'components/Wizards/MobileWizards/MobileWizard/components/StartWithMedia/utils'

const BASE_HIDDEN: Provider[] = ['gifs', 'blazeRecommendations']

const getHiddenProviders = (mediaTypes: SupportedMediaType[], additional?: Provider[]): Provider[] => {
  const extras: Provider[] = []
  if (!mediaTypes.includes('image')) extras.push('stockPhoto', 'ai', 'hardcodedAi')
  if (!mediaTypes.includes('video')) extras.push('stockVideo')
  return Array.from(new Set([...BASE_HIDDEN, ...extras, ...(additional ?? [])]))
}

export const ReferenceImageTrigger = ({
  onUse,
  children,
  mediaTypes = ['image'],
  additionalHiddenProviders,
  ...props
}: ReferenceImageTriggerProps) => {
  return (
    <ModalTrigger
      modal={ImageMenuModal}
      uploadMedia
      action="Change"
      accept={getMimeTypesForMediaTypes(mediaTypes)}
      maxCount={1}
      showSearchBar
      hiddenProviders={getHiddenProviders(mediaTypes, additionalHiddenProviders)}
      onUse={(images: ImageMenuSelectedImage[]) =>
        onUse({
          id: images[0].id as string,
          key: images[0].id as string,
          source_url: images[0].source_url || '',
          url: images[0].url,
          thumbnail_url: images[0].thumbnail_url,
          duration: images[0].duration,
        })
      }
      {...props}
    >
      {children}
    </ModalTrigger>
  )
}
